import React, {Component} from 'react'

class keywordDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            img:"",
            text:"",
        };

    }

    render() {
        let data = this.props.keywordDetail;
        return (
            <div className={this.props.close === true || !data ? 'doc_outwrap' : 'doc_outwrap active'} onClick={(e)=>this.props.hideDetail()}>
                <div className={this.props.close === true || !data ? 'docViewer' : 'docViewer active'} onClick={(e)=>e.stopPropagation()}>
                    <button className="docClose" onClick={() => this.props.hideDetail()}
                            style={{display: this.props.close === true || !data ? 'none' : 'inline-block'}}>
                        <i className="fas fa-angle-right"/>
                    </button>
                    <div className="docCon">
                        <div id="articles">
                            <h3>{data.Title}</h3>

                            {(data.Journal_title !== "" && data.Journal_title !== "Unknown") && 
                                <React.Fragment>
                                    <h6>Published in</h6>
                                    <h5><span>{data.Journal_title}</span></h5>
                                </React.Fragment>
                            }

                            {(data.Authors !== "" && data.Authors !== "Unknown") && 
                                <React.Fragment>
                                    <h6>Published by</h6>
                                    <h5><span>{data.Authors}</span></h5>
                                </React.Fragment>
                            }
                            <div className={data.Year === "1000" ? "c50 hidden" : "c50"}><h6>Publication Date</h6><h5>{data.Year}</h5></div>
                            <div className={data.Cited_by === "0" ? "c50 hidden" : "c50"}><h6>Cited by</h6><h5>{data.Cited_by}</h5></div>

                            {(data.Summary !== "" && data.Summary !== "Unknown") && 
                                <p>{data.Summary}</p>
                            }

                            {data.Link_url !== "Unknown" ?
                                <a target="_blank" href={data.Link_url}>
                                    Read more
                                </a>
                                :
                                <a href={'javascript:void()'} className="disable">
                                    Read more
                                </a>
                            }
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}


export default keywordDetail; 

